import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import GlobalButton from "../../components/button";
import ProductCard from "../../components/cards/ProductCard";
import ProductData from "../../json/Products.json";

const Products = () => {
  return (
    <Box component={"section"} bgcolor={"text.raisinBlack"} py={6}>
      {/* <svg
        width="100%"
        height="100px"
        viewBox="0 0 1600 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position:"relative",
          top:"-5px"
        }}
      >
        <path
          id="Wave 2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.894144 14.8749C0.894144 14.8749 247.357 51.9059 374.584 45.5936C501.811 39.2813 533.496 37.4948 601.406 45.5936C669.316 53.6924 993.53 115.464 1144.38 107.975C1295.23 100.485 1541.8 56.3355 1599.58 93.3802V0.358398H0L0.894144 14.8749Z"
          fill="white"
        />
      </svg> */}

      <Typography
        variant="heading_pr"
        component={"h1"}
        color={"text.white"}
        textAlign={"center"}
      >
        Explore All Products
      </Typography>
      <Container sx={{ maxWidth: "1100px !important", mt: 10 }}>
        <Grid container spacing={2}>
          {ProductData.slice(0, 12).map((item, index) => (
            <Grid key={index} item xs={12} sm={4} md={3}>
              <ProductCard cardData={item} />
            </Grid>
          ))}
        </Grid>

        <Stack my={5} alignItems={"center"}>
          <GlobalButton
            btnText={"Check All Products"}
            styleProps={{
              height: 50,
              width: 200,
              backgroundColor: "text.white",
              color: "text.black",
              borderRadius: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
            }}
          />
        </Stack>
      </Container>
    </Box>
  );
};

export default Products;
